
import { SensorIssuesService } from "../../services/sensor_issues/service";
import mapSensorIssueDataFromJson from "../../domain/sensor_issues/mapper";

const baseUrl = process.env.VUE_APP_BASIC_URL;
const sensorIssuesService = new SensorIssuesService(baseUrl, mapSensorIssueDataFromJson);

const getDefaultState = () => {
  return {
    sensorIssues: [],
    fetchLoading: true,
    fetchError: null,
  };
};

const state = getDefaultState();

const getters = {
  fetchRequestFailed: (state) => (state.fetchError !== null),
  emptyIssues: (state) => (state.sensorIssues.length === 0 && !state.fetchError && !state.fetchLoading),
};

const actions = {
  async fetchSensorIssues({ commit }, payload) {
    commit("SET_FETCH_LOADING_STATE");
    try {
      const sensorIssues = await sensorIssuesService.getSensorIssuesVessel(

        localStorage.getItem("quad_token"),
        payload.name,
        payload.startDate,
        payload.stopDate
      );
      commit("SET_FETCH_SUCCESS_STATE", sensorIssues.filter((issue) => issue.isPersistent));
    } catch (error) {
      commit("SET_FETCH_ERROR_STATE", error);
    }
  }
};

const mutations = {
  SET_FETCH_LOADING_STATE(state) {
    state.fetchLoading = true;
  },
  SET_FETCH_SUCCESS_STATE(state, sensorIssues) {
    state.sensorIssues = sensorIssues;
    state.fetchLoading = false;
  },
  SET_FETCH_ERROR_STATE(state, error) {
    state.fetchError = error;
    state.sensorIssues = [];
    state.fetchLoading = false;
  }
};

export const sensorIssuesModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
